<div class="rename-layer-dialog">
    <div class="dialog-header title">
        <div>Rename Layer</div>
    </div>

    <form [formGroup]="renameForm">
        <div class="dialog-content">
            <cds-input class="form-group">
                <label for="newName">New Name</label>
                <input
                    id="newName"
                    type="text"
                    formControlName="newName"
                    placeholder="Enter new layer name"
                    [disabled]="isSubmitting"
                />
                <div
                    class="error-message"
                    *ngIf="renameForm.get('newName')?.invalid && renameForm.get('newName')?.touched"
                >
                    <span *ngIf="renameForm.get('newName')?.errors?.['required']"
                        >Name is required</span
                    >
                    <span *ngIf="renameForm.get('newName')?.errors?.['minlength']"
                        >Name must be at least 1 character</span
                    >
                    <span *ngIf="renameForm.get('newName')?.errors?.['specialSymbol']"
                        >Name cannot contain special symbols</span
                    >
                </div>
            </cds-input>
        </div>

        <div class="actions action-buttons">
            <cds-button size="sm" action="flat" (click)="onCancel()" [disabled]="isSubmitting"
                >Cancel</cds-button
            >
            <cds-button
                size="sm"
                (click)="onSubmit()"
                [disabled]="renameForm.invalid || isSubmitting"
            >
                <span *ngIf="isSubmitting">Renaming...</span>
                <span *ngIf="!isSubmitting">Rename</span>
            </cds-button>
        </div>
    </form>
</div>
